import { ReactNode, useMemo } from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import { ScrollView, YStack, getTokens, useMedia } from 'tamagui'
import { useThemeColor } from '@hooks/useThemeColor'

interface IOrdersLayoutProps {
  children: ReactNode
}
export function OrdersLayout({ children }: IOrdersLayoutProps) {
  const media = useMedia()

  const paddingHorizontal = useMemo(() => {
    const sizes = getTokens().size

    return sizes[media.gtSm ? '$spacing-xsl' : '$spacing-xs'].val
  }, [media.gtSm])

  const paddingBottom = getTokens().size['$spacing-xxl'].val
  const background = useThemeColor('bg-page')

  return (
    <SafeAreaView
      style={{ flex: 1, backgroundColor: background }}
      edges={['top', 'bottom']}
    >
      <ScrollView
        backgroundColor="$bg-page"
        contentContainerStyle={{
          paddingHorizontal,
          paddingBottom,
        }}
      >
        <YStack
          marginTop="$spacing-inset-lg"
          p={'$size.spacing-xs'}
          backgroundColor="$bg-surface"
          gap="$size.spacing-md"
          br="$border-radius-md"
          width="100%"
          $gtSm={{
            padding: '$size.spacing-md',
          }}
          $gtLg={{
            maxWidth: 1608,
            marginHorizontal: 'auto',
            padding: '$size.spacing-lg',
          }}
        >
          {children}
        </YStack>
      </ScrollView>
    </SafeAreaView>
  )
}
